import React from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, Grid } from 'housecall-ui';

import { IMAGE_LIMIT } from '../../src/components/photos/consts';
import UploadPhotosInput from '../../src/components/photos/UploadPhotosInput';
import { useLeadCaptureSettings } from '../hooks/useLeadCaptureSettings';
import { useUploadPhoto } from '../hooks/useUploadPhoto';

import PhotoPreview from './PhotoPreview';

const UploadFiles = () => {
  const { token } = useParams<{ token: string }>();
  const { data } = useLeadCaptureSettings();
  const { uploadPhoto, photos } = useUploadPhoto({
    token,
  });

  const onChange = (addedPhotos: File[]) => {
    addedPhotos.forEach((photo) => {
      uploadPhoto(photo);
    });
  };

  return (
    <>
      {photos.length === IMAGE_LIMIT ? (
        <Box mb={2}>
          <Alert severity="warning">You&apos;ve reached the maximum limit of 10 pictures per booking</Alert>
        </Box>
      ) : (
        <Box mb={2}>
          <UploadPhotosInput
            label={data?.fields_to_capture_settings.file_upload_button_text}
            description={data?.fields_to_capture_settings.file_upload_text}
            onChange={onChange}
            photos={photos}
          />
        </Box>
      )}
      {photos && (
        <Grid item xs={12}>
          {Array.from(photos).map((photo) => (
            <Box my={2} key={photo.file.name}>
              <PhotoPreview photo={photo} />
            </Box>
          ))}
        </Grid>
      )}
    </>
  );
};

export default UploadFiles;
